/**
 * 文件说明:
 *
 * 名创多主体配置
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {cloneDeep} from 'lodash'

const multiAgentArray = [
    // 名创优品
    {
        constant: 'mainMiniso',
        key: 'MainMiniso',
        envCorpIdsMap: {
            development: ['wwd20f514bbf957359'],
            'production-develop': ['wwd20f514bbf957359'], // 猫赞
            'production-test': ['ww69939f797bff51ad', 'ww8d7ac72569657542', 'wweb17dcfb1c200027'], // 大名创 腾讯智慧零售（上海）,
            'production-master': ['ww4abcb1ece769fb53', 'ww69939f797bff51ad'], // [大名创, 腾讯智慧零售（上海）],
        },
    },
    // Miniso名创优品
    {
        constant: 'miniso',
        key: 'Miniso',
        envCorpIdsMap: {
            development: ['wwd20f514bbf957359'],
            'production-develop': ['wwd20f514bbf957359'], // 猫赞
            'production-test': ['ww0a037052f45994d7', 'wwbd6d4fb76ae078c0'], // 承生农业, 上海承生
            'production-master': ['ww5446430e844b22f0', 'wwe0a048529f9ccb48'],
        },
    },
    // 大潮玩、黑洞
    {
        constant: 'topToy',
        key: 'topToy',
        envCorpIdsMap: {
            development: ['wwd20f514bbf957359'],
            'production-develop': ['wwd20f514bbf957359'], // 猫赞
            'production-test': ['ww15c9031b044c9395', 'wwe0a048529f9ccb48', 'ww5091331737f5bed0'], // [虎赞精选, 口袋金服, pintea]
            'production-master': ['ww5d58aa112bf71542', 'ww389cb02a344639df', 'ww5091331737f5bed0'], // [大潮玩, 黑洞, pintea ]
        },
    },
    // WOWCOLOUR
    {
        constant: 'wowColour',
        key: 'WOWCOLOUR',
        envCorpIdsMap: {
            development: ['wwd20f514bbf957359'],
            'production-develop': ['wwd20f514bbf957359'], // 猫赞
            'production-test': ['wwbd6d4fb76ae078c0'], // 上海承生
            'production-master': ['ww89bb7d8c453726e2'],
        },
    },
]

const multiAgentMap = new Map()

const companyNameMap = {}

for (const multiAgentInfo of multiAgentArray) {
    const newMultiAgentInfo = cloneDeep(multiAgentInfo)

    multiAgentMap.set(multiAgentInfo.key, {
        ...newMultiAgentInfo,
        corpIds: multiAgentInfo?.envCorpIdsMap?.[HUZAN_ENV] ?? [],
    })

    companyNameMap[multiAgentInfo.key] = multiAgentInfo.constant
}

export function getCompanyNameMap() {
    return companyNameMap
}

export function getMultiAgentInfoByCorpId(corpId) {
    for (const [, multiAgent] of multiAgentMap) {
        const {corpIds} = multiAgent
        if (corpIds.includes(corpId)) {
            return multiAgent
        }
    }
}
